<template>
    <div class="BdoDialog" v-if="isShow">
        <div class="dialog">
            <h2>Welcome back, {{text.title}}!</h2>
            <p>You are about to resume your </p>
            <p><span>{{text.mesg}}</span> merchant application.</p>
            <el-button class="dialogBtn" @click="cancel">Continue</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "BdoDialog",
    data() {
        return {
            text: {
                title: '',
                mesg: ''
            },
            isShow: true
        }
    },
    methods: {
        cancel() {
            this.isShow = false
        }
    }
}
</script>
<style lang="scss" scoped>
.BdoDialog {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.45);
    z-index: 999;
    .dialog {
        width: 428px;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 8px #00000014;
        border-radius: 16px;
        overflow: hidden;
        text-align: center;
        margin: 300px auto 0;
        h2 {
            margin: 32px 0 23px;
            font: normal normal normal 24px/32px Nunito-bold;
            letter-spacing: 0px;
            color: #2E2E2E;
        }
        p {
            font: normal normal normal 16px/24px Nunito;
            letter-spacing: 0px;
            color: #2E2E2E;
            span {
                font: normal normal normal 16px/24px Nunito-bold;
            }
        }
        .dialogBtn {
            margin: 32px auto;
            width: 324px;
        }
    }
    position: absolute;
    left: 0;
    top: 0;
}
</style>